<quill-editor
    [(ngModel)]="content"
    format="object"
    style="width: 100%"
    [placeholder]="placeholderText"
    (onContentChanged)="onFirstInput()"
></quill-editor>
<!-- <p *ngIf="hasTyped" class="help-block">
    Tag people with "&#x40;", RPA with "&#x23;RPA", and batteries with
    "&#x23;BATTERY"
</p> -->
<div class="pull-right" style="margin-top: 10px">
    <button *ngIf="hasCancel" class="btn btn-inline" (click)="onCancel()">
        Cancel
    </button>
    <button
        *ngIf="hasSave"
        class="btn btn-inline btn-inline-primary-action"
        (click)="onSave()"
        [disabled]="content == null"
    >
        Save
    </button>
</div>
